import ApiRequest from '../api/ApiRequest';

const apiRequest = new ApiRequest('users');

export default {
  state: {
    users: [],
    offices: [],
  },
  namespaced: true,
  mutations: {
    async saveUsersStore(state, users) {
      state.users = users;
    },
    async createUser(state, user) {
      const users = state.users.concat(user.data);
      state.users = users;
    },
    async updateUser(state, user) {
      const index = state.users.findIndex((el) => el.id === user.data.id);
      Object.assign(state.users[index], user.data);
    },
    async getOffices(state, data) {
      state.offices = data;
    },
  },
  actions: {
    async saveUsersStore({ commit }, data) {
      commit('saveUsersStore', await apiRequest.getAll(data));
    },
    async createUser({ commit }, user) {
      commit('createUser', await apiRequest.create(user));
    },
    async updateUser({ commit }, user) {
      commit('updateUser', await apiRequest.update(user));
    },
    async getOffices({ commit }) {
      commit('getOffices', await apiRequest.get('office'));
    },
  },
  getters: {
    getUsers: (state) => state.users,
    offices: (state) => state.offices,
  },
};
